
const underconstruction = [
    {
        "key": "underconstruction.title",
        "string": "Spletna stran v izdelavi!"
    },
    {
        "key": "underconstruction.text",
        "string": "Obveščamo vas, da je spletna stran še v izdelavi. Hvala za razumevanje."
    }
]

export default underconstruction



// WEBPACK FOOTER //
// ./src/i18n/sl/landingpage/underconstruction.js